export default function ParentsWeekendScan(){
    return (
        <>
            <img src='parents-weekend-scan.jpg' style={{maxWidth:'100%'}} />
            

        </>
    )
}